namespace advisorop.components.common {

    class VwInvestorController
    {
        investor: domains.IInvestor;
        loginDates: Date[];
        user: domains.identity.IUser;
        investorLoginType: domains.SystemLoginType = domains.SystemLoginType.INVESTOR;
        isAdvisorUser = false;
        analystData: domains.ISalesforceAnalystData = null;

        static $inject = ["identityService", "advisorService", "generalService", "$scope"];
        constructor(private identityService: services.IdentityService, private advisorService: services.AdvisorService, private generalService: services.GeneralService, private $scope: ng.IScope) {
        }

        getLoginDates() {
            if (this.investor.id != undefined) {
                this.generalService.getInvestorLogins(this.investor.id, 5)
                    .success(results => {
                        this.loginDates = results;
                    })
            }
        }

        loadAnalystData() {
            if (this.investor?.id && this.isAdvisorUser) {
                this.advisorService.getInvestorAnalyst(this.investor.id)
                    .then(response => {
                        this.analystData = response.data;
                    })
                    .catch(() => {
                        this.analystData = null;
                    });
            }
        }

        emailUsernameMismatch(): boolean {
            return (this.investor?.contactEmail
                && this.investor.contactEmail != ""
                && this.investor.systemLogin?.username
                && this.investor.systemLogin.username != ""
                && this.investor.contactEmail.toUpperCase() != this.investor.systemLogin.username.toUpperCase());
        }

        matchLoginToEmail() {
            if (window.confirm(`Are you sure you want to change this investor's username from "${this.investor.systemLogin.username}" to "${this.investor.contactEmail}"?`)) {
                this.advisorService.updateInvestorUsernameToMatchEmail(this.investor.id)
                    .then(data => {
                        toastr.success("The user ID has been changed to " + this.investor.contactEmail);
                        this.investor.systemLogin.username = this.investor.contactEmail;
                    })
                    .catch(err => {
                        this.generalService.showError(err);
                    })
            }
        }

        $onChanges(evt): void {
            for (var key in evt) {
                if (key === "investor") {
                    if (this.investor != undefined) {
                        this.getLoginDates();
                        this.loadAnalystData();
                    }
                }
            }
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                this.isAdvisorUser = (
                    this.user.role === "ADVISORY"
                    || this.user.role === "ADVISORY_LEAD"
                    || this.user.role === "ADVISORY_ADMIN"
                );
            });
        }
    }


    class VwInvestor implements ng.IComponentOptions
    {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = VwInvestorController;
            this.controllerAs = "vm";
            this.bindings = {
                investor: "<"
            };
            this.templateUrl = "spa/shared/common/vw-investor.html";
        }

    }
    angular.module(Constants.APP).component("vwInvestor", new VwInvestor());


}